var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.367,
    height: 43.365,
    viewBox: "0 0 43.367 43.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BZYGmV",
    transform: "translate(0 335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(0 -335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-1",
    d: "M151.538,136.9a21.683,21.683,0,1,1-21.666,21.739A21.724,21.724,0,0,1,151.538,136.9Zm-2.951,36.6h5.2V160.192h5.326V155.7H153.8c0-1.034,0-2.042,0-3.05a1.81,1.81,0,0,1,.35-1.174.648.648,0,0,1,.353-.237,6.976,6.976,0,0,1,1.017-.082c1.1-.016,2.2-.024,3.3-.019.246,0,.309-.082.308-.317-.007-1.4,0-2.8,0-4.205,0-.081-.009-.161-.014-.252-.066-.006-.115-.013-.164-.013-1.485,0-2.971-.007-4.456.013a5.012,5.012,0,0,0-2.506.68,6.629,6.629,0,0,0-3.4,5.805c-.032.858-.007,1.719-.008,2.578,0,.088,0,.177,0,.291H144v4.489h4.588Z",
    transform: "translate(-129.871 -136.901)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.3cd5b1e7.svg";
export { ForwardRef as ReactComponent };